import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { createPointPackage, editPointPackage,
seePointPackages, deletePointPackage, deactivatePointPackage,
deactivateAllPointPackage } from '../../actions/markActions';
import { Translate } from '../../../language';
import inMemoryJWT from '../../../auth/inMemoryJwt';

const PointPackageAdmin = ({ history, createPointPackage, isLoadingListPointPackages, listPointPackages, editPointPackage, seePointPackages, deletePointPackage, deactivatePointPackage, deactivateAllPointPackage }) => {

    useEffect(() => {
        if(!(inMemoryJWT.getToken())){
            inMemoryJWT.getRefreshedToken()
        }

        inMemoryJWT.waitForTokenRefresh().then(() => {
            seePointPackages()
        })
        
    },[])

    const [pointsQuantity, setPointsQuantity] = useState('')
    const [description, setDescription] = useState('')
    const [price, setPrice] = useState('')
    const [checkIsDefault, setCheckIsDefault] = useState(false)
    const [isEnable, setIsEnable] = useState(false)
    const [error, setError] = useState({})
    const [isValidate, setValidate] = useState(false)
    const [isEdit, setIsEdit] = useState(false)
    const [idEdit, setIdEdit] = useState('')
    const [indexEdit, setIndexEdit] = useState('')


    const isEmpty = (e) => {
        if (description !== '' && price !== '' && pointsQuantity !== '') {
            setValidate(true)
        }
        const { name, placeholder, value } = e.target;
        if (value.length === 0) {
            setValidate(false)
            setError(prevError => ({
                ...prevError,
                [name]: Translate('missingField', 'es') + placeholder
            }));
        }
        if (value.length !== 0) {

            setError(prevError => ({
                ...prevError,
                [name]: ''
            }));
        }

    }

    const isFocused = (e) => {
        const { name } = e.target;
        setError(prevError => ({
            ...prevError,
            [name]: ''
        }));
    }
useEffect(() => {
    if (description !== '' && price !== '' && pointsQuantity !== '') {
        setValidate(true)
    }
}, [price])

useEffect(() => {
    if (description !== '' && price !== '' && pointsQuantity !== '') {
        setValidate(true)
    }
}, [pointsQuantity])
    return (
        <div className="container-mark-type-admin">
            <div className="new-edit-type-mark-container-admin">
                <div className='title-admin'>{`${isEdit ? 'Editar' : 'Nuevo'} paquete de puntos`}</div>
                <div className="container-inputs-new-mark">
                    <div className="text-input-admin">
                        {'Cantidad de puntos:'}
                    </div>
                    <input className='inputs-admin'
                        name="pointsQuantity"
                        type="number"
                        min='1'
                        value={pointsQuantity}
                        onBlur={e => isEmpty(e)}
                        onFocus={e => isFocused(e)}
                        onKeyUp={e => isEmpty(e)}
                        onChange={(e) => {
                            setPointsQuantity(e.target.value.trimStart())
                            if (description !== '' && price !== '' && pointsQuantity !== '') {
                                setValidate(true)
                            }
                        }}
                        autoComplete="off">
                    </input>
                    <div className="text-error text-error-admin">{error.name}</div>
                    <div className="text-input-admin">
                        {'Descripción:'}
                    </div>
                    <input className='inputs-admin'
                        name="description"
                        type="text"
                        value={description}
                        onBlur={e => isEmpty(e)}
                        onFocus={e => isFocused(e)}
                        onKeyUp={e => isEmpty(e)}
                        onChange={(e) => {
                            setDescription(e.target.value.trimStart())
                            if (description !== '' && price !== '' && pointsQuantity !== '') {
                                setValidate(true)
                            }
                        }}
                        autoComplete="off">
                    </input>
                    <div className="text-error text-error-admin">{error.description}</div>
                    <div className="text-input-admin">
                        {'Precio:'}
                    </div>
                    <input className='inputs-admin'
                        name="price"
                        type="text"
                        value={price}
                        onBlur={e => isEmpty(e)}
                        onFocus={e => isFocused(e)}
                        onKeyUp={e => isEmpty(e)}
                        onChange={(e) => {
                            setPrice(e.target.value.trimStart())
                            if (description !== '' && price !== '' && pointsQuantity !== '') {
                                setValidate(true)
                            }
                        }}
                        autoComplete="off">
                    </input>
                    <div className="text-error text-error-admin">{error.price}</div>
                    {isEdit ?
                        <div className="content-buttom-create-admin">
                            <button className={`btns-admin btn-create-edit btns-admin-inactive`} onClick={() => {
                                setPointsQuantity('')
                                setDescription('')
                                setPrice('')
                                setIsEnable(false)
                                setIsEdit(false)
                                setIndexEdit('')
                            }}>
                                {Translate('cancel', 'es')}
                            </button>
                            <div className="ml-1 mr-1"></div>
                            <button disabled={isValidate ? '' : 'disabled'}
                                className={`btns-admin btn-create-edit ${isValidate ? '' : 'btns-admin-inactive'}`} onClick={() => {
                                    editPointPackage({ pointsQuantity: pointsQuantity, description: description, price: price, isEnabled: isEnable, packageId: idEdit }, history, indexEdit)
                                    setPointsQuantity('')
                                    setDescription('')
                                    setIsEnable(false)
                                    setPrice('')
                                    setIsEdit(false)
                                    setIndexEdit('')
                                }}>
                                {Translate('edit', 'es')}
                            </button>
                        </div>

                        :
                        <div className="content-buttom-create-admin">
                            <button disabled={isValidate ? '' : 'disabled'}
                                className={`btns-admin btn-create-edit ${isValidate ? '' : 'btns-admin-inactive'}`} onClick={() => { 
                                    
                                    createPointPackage({ pointsQuantity: pointsQuantity.trim(), description: description.trim(), price: price.trim(), isDefault: checkIsDefault }, history)
                                    setPointsQuantity('')
                                    setDescription('')
                                    setPrice('')
                                    setIsEnable(false)
                                    setIsEdit(false)
                                    setIndexEdit('')
                                    
                                    }}>
                                {Translate('create', 'es')}
                            </button>
                        </div>
                    }
                </div>
            </div>
            <div className="see-all-mark-type-admin">
                <div className='title-admin-list'>Paquetes existentes</div>
                <div className='wrapper-2 column-gap row-gap mt-3'>
                    {isLoadingListPointPackages ? <div>Cargando...</div> :
                        listPointPackages.map((pointPackage, index) => (
                            <div className="mb-2 row mr-3 ml-2 card-admin">
                                <div className="tittle-card-admin">{pointPackage.pointsQuantity}</div>
                                <div className="text-content-card ">${pointPackage.price}</div>
                                <div className="text-content-card ">{pointPackage.description}</div>
                                <div className="column centerContent">
                                    <div className="btns-admin ml-1 mr-1" onClick={() => {
                                        setPointsQuantity(pointPackage.pointsQuantity)
                                        setDescription(pointPackage.description)
                                        setPrice(pointPackage.price)
                                        setIsEnable(pointPackage.isEnable)
                                        setIdEdit(pointPackage._id)
                                        setIndexEdit(index)
                                        setIsEdit(true)
                                    }}>Editar</div>
                                    <div className="btns-admin btns-admin-red" onClick={() => { deletePointPackage(pointPackage._id, index) }}>Eliminar</div>
                                    <div className="btns-admin ml-1 btns-admin-inactive" onClick={() => { deactivatePointPackage(pointPackage._id, index) }}>Desactivar</div>
                                </div>

                            </div>

                        ))
                    }
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        isLoadingListPointPackages: state.markAdmin.isLoadingListPointPackages,
        listPointPackages: state.markAdmin.listPointPackages
    }
}


export default connect(mapStateToProps, { createPointPackage, editPointPackage, seePointPackages, deletePointPackage, deactivatePointPackage, deactivateAllPointPackage })(PointPackageAdmin)
